// Функция для преобразования px в rem
const pxIntoRem = (px: number): string => `${px / 16}rem`;

export { pxIntoRem };
